module.exports = __webpack_public_path__ + "static/media/Bruger_manual_ST-609.43634d75.pdf";